import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import InputField from '@components/common/InputField/InputField.component'
import {
  ProviderPersonalInfo,
  ProviderValidationErrors,
} from '@dataTypes/provider.types'
import { US_STATE_OPTIONS } from '@constants/Providers'
import { APIProvider } from '@vis.gl/react-google-maps'
import AddressField from '@components/common/AddressField/AddressField.component'
import { getEnv } from '@utils/env'

const GOOGLE_MAPS_API_KEY = getEnv('REACT_APP_GOOGLE_MAPS_API_KEY', '')

type AddressFieldsProps = {
  providerData: Pick<ProviderPersonalInfo, 'address' | 'city' | 'state' | 'zip'>
  handleInputChange: (field: string, value: string | boolean | number) => void
  validationErrors: ProviderValidationErrors
}

const AddressFields: React.FC<AddressFieldsProps> = ({
  providerData,
  handleInputChange,
  validationErrors,
}) => {
  return (
    <Row className="mb-2 gx-2">
      <Col md={12} className="mb-2">
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={['places']}>
          <div>
            <AddressField
              label="Address"
              placeholder="Enter an address"
              value={providerData.address || ''}
              onChange={(value) => handleInputChange('address', value)}
              countries={['US']}
              onSelect={(_place, parsed) => {
                handleInputChange('address', parsed.formattedAddress2 ?? '')
                handleInputChange('city', parsed.city ?? '')
                handleInputChange('state', parsed.state ?? '')
                handleInputChange('zip', parsed.postalCode ?? '')
              }}
              hint={validationErrors.address || undefined}
              destructive={!!validationErrors.address}
            />
          </div>
        </APIProvider>
      </Col>
      <Col md={6} className="city-field">
        <InputField
          label="City/town"
          placeholder="Enter a city"
          value={providerData.city || ''}
          onChange={(e) => handleInputChange('city', e.target.value)}
          hint={validationErrors.city || undefined}
          destructive={!!validationErrors.address}
        />
      </Col>
      <Col>
        <Form.Group controlId="formState">
          <Form.Label>State</Form.Label>
          <Form.Select
            value={providerData.state || ''}
            onChange={(e) => handleInputChange('state', e.target.value)}
            className={
              validationErrors.address ? 'form-select-destructive' : ''
            }
          >
            <option value="">--</option>
            {US_STATE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
          {validationErrors.state && (
            <div className="hint-text">{validationErrors.state}</div>
          )}
        </Form.Group>
      </Col>
      <Col style={{ maxWidth: '80px' }}>
        <InputField
          label="ZIP"
          value={providerData.zip || ''}
          onChange={(e) => handleInputChange('zip', e.target.value)}
          hint={validationErrors.zip || undefined}
          destructive={!!validationErrors.address}
        />
      </Col>
    </Row>
  )
}

export default AddressFields
